import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IAuthStrategy } from './auth-strategy.interface';
import { 
    IAuthResponse, 
    IStandardAuthCredentials, 
    ILoginPayload,
    AuthType 
} from '../../models/auth.models';
import { WebService } from '../web/web.service';
import { LoggerService } from '../logger.service';

/**
 * Estrategia de autenticación estándar (usuario/contraseña)
 * Implementa el patrón Strategy
 */
@Injectable({
    providedIn: 'root'
})
export class StandardAuthStrategy implements IAuthStrategy {
    private readonly loginUrl: string;

    constructor(
        private http: HttpClient,
        private webService: WebService,
        private logger: LoggerService
    ) {
        this.loginUrl = `${this.webService.HOST}/auth/login`;
    }

    authenticate(credentials: IStandardAuthCredentials): Observable<IAuthResponse> {
        this.logger.log('🔐 [STANDARD-AUTH-STRATEGY] ========================================');
        this.logger.log('🔐 [STANDARD-AUTH-STRATEGY] Iniciando autenticación estándar');
        this.logger.log('🔐 [STANDARD-AUTH-STRATEGY] URL:', this.loginUrl);
        this.logger.log('👤 [STANDARD-AUTH-STRATEGY] Username:', credentials.username);
        this.logger.log('🔑 [STANDARD-AUTH-STRATEGY] Password: ********');

        const payload: ILoginPayload = {
            username: credentials.username,
            password: credentials.password,
            partner: null,
            authType: AuthType.STANDARD
        };

        this.logger.log('📦 [STANDARD-AUTH-STRATEGY] Payload a enviar:', {
            username: payload.username,
            password: '********',
            partner: payload.partner,
            authType: payload.authType
        });
        this.logger.log('📤 [STANDARD-AUTH-STRATEGY] Enviando request al backend...');

        return this.http.post<IAuthResponse>(this.loginUrl, payload);
    }
}
